import React, { useState, useEffect, useCallback } from 'react';

const API = window.location.origin;

const STATUS_COLORS = {
  green: '#34d399',
  amber: '#fbbf24',
  red: '#f87171',
};

export const ApiBudgetGauge = () => {
  const [budget, setBudget] = useState(null);
  const [expanded, setExpanded] = useState(true);

  const fetchBudget = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const res = await fetch(`${API}/api/grid-bot/request-budget`, { headers });
      if (!res.ok) return;
      setBudget(await res.json());
    } catch { /* keep last value */ }
  }, []);

  useEffect(() => {
    fetchBudget();
    const id = setInterval(fetchBudget, 60000);
    return () => clearInterval(id);
  }, [fetchBudget]);

  const color = STATUS_COLORS[budget?.status] || '#6b7280';
  const pct = budget?.available && budget.requests_cap > 0
    ? Math.min(100, Math.max(0, (budget.requests_used / budget.requests_cap) * 100))
    : 0;

  return (
    <div data-testid="api-budget-gauge" style={{ marginBottom: 14 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: '#9ca3af' }}>API Request Budget</span>
        <button
          type="button"
          data-testid="api-budget-toggle"
          onClick={() => setExpanded((v) => !v)}
          style={{ background: 'none', border: 'none', color: '#6b7280', cursor: 'pointer', fontSize: 11, padding: 0 }}
        >
          {expanded ? '▾' : '▸'}
        </button>
        {budget?.available && (
          <span
            data-testid="api-budget-headroom"
            style={{ marginLeft: 'auto', fontSize: 12, fontWeight: 700, color }}
          >
            {budget.headroom.toLocaleString()} left
          </span>
        )}
      </div>
      {expanded && (
        !budget ? (
          <div style={{ fontSize: 12, color: '#6b7280' }}>Loading…</div>
        ) : !budget.available ? (
          <div data-testid="api-budget-unavailable" style={{ fontSize: 12, color: '#6b7280', background: '#111827', borderRadius: 6, padding: '8px 10px' }}>
            Budget unavailable: {budget.reason}
          </div>
        ) : (
          <div style={{ background: '#111827', borderRadius: 6, padding: '10px 12px' }}>
            <div
              data-testid="api-budget-bar"
              style={{ height: 8, background: '#374151', borderRadius: 4, overflow: 'hidden', marginBottom: 8 }}
            >
              <div style={{ width: `${pct}%`, height: '100%', background: color, transition: 'width 0.6s ease' }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#9ca3af' }}>
              <span data-testid="api-budget-used">Used {budget.requests_used.toLocaleString()} / {budget.requests_cap.toLocaleString()}</span>
              <span style={{ color }}>
                {budget.status === 'green' && 'Healthy'}
                {budget.status === 'amber' && `Low — below ${budget.thresholds.amber_below.toLocaleString()}`}
                {budget.status === 'red' && `Critical — below ${budget.thresholds.red_below.toLocaleString()}`}
              </span>
            </div>
            <div style={{ fontSize: 10, color: '#6b7280', marginTop: 6 }}>
              Hyperliquid grants ~1 order action per $1 traded (+10k base). Headroom shrinks with idle churn and grows with fills.
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default ApiBudgetGauge;
